import moment from 'moment'

export class NotFoundError extends Error {

    constructor(message, type, data) {
        super(message)
        this.stack = (new Error()).stack
        this.name = 'NotFoundError'
        this.message = message
        this.statusCode = 404
        this.type = type
        this.data = data
    }
}

export class UnauthorizedError extends Error {

    constructor(message, type, data) {
        super(message)
        this.stack = (new Error()).stack
        this.name = 'UnauthorizedError'
        this.message = message
        this.statusCode = 401
        this.type = type
        this.data = data
    }
}

export class ForbiddenError extends Error {

    constructor(message, type, data) {
        super(message)
        this.stack = (new Error()).stack
        this.name = 'ForbiddenError'
        this.message = message
        this.statusCode = 403
        this.type = type
        this.data = data
    }
}

export class ServerError extends Error {

    constructor(message, statusCode, type, data) {
        super(message)
        this.stack = (new Error()).stack
        this.name = 'ServerError'
        this.message = message
        this.statusCode = statusCode
        this.type = type
        this.data = data
    }
}

export function jsonOption(option = {}) {
    const defaultOption = {
        method: 'post',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }

    return {...defaultOption, ...option, body: JSON.stringify(option.body)}
}

export function cookieOption(option = {}) {
    const defaultOption = {
        credentials: 'include'
    }

    return {...defaultOption, ...option}
}

export function apiOption(option = {}) {
    return cookieOption(option.body && jsonOption(option) || option)
}

export function apiUrl(url, query = {}) {
    
    function stringify(value) {
        if (value instanceof Date) return moment(value).format('YYYY-MM-DD')
        return value
    }

    function sanitize(value) {
        if (value === 0 || value === false) return value
        return value || null
    }

    const queryArray = Object.keys(query).reduce((result, key) => {
        var value = query[key]

        if (value == null) {
            value = []
        } else if (value instanceof Array) {
            value = value.map((v) => sanitize(stringify(((typeof v == 'object') && v.uid || v.value) || v)))
        } else if (value instanceof Date) {
            value = sanitize(stringify(value))
            value = [value]
        } else if (typeof value == 'object') {
            value = sanitize(Object.keys(value).map((k) => stringify(value[k])).join(Object.keys(value).length == 2 && '-' || ','))
            value = [value]
        } else {
            value = sanitize(value)
            value = [value]
        }

        value.filter((value) => value != null).forEach((value) => {
            result.push(key.toLowerCase() + '=' + encodeURIComponent(value))
        })
        return result
    }, [])

    const queryString = queryArray.length > 0 && ('?' + queryArray.join('&')) || ''
    return url + queryString
}

export function errorResponse(response, option = {}) {
    if (response.status >= 200 && response.status < 300) {
        return response
    }

    if (option.status && option.status.indexOf(response.status) >= 0) {
        return response
    }

    return getSafeJson(response).then((json) => {
        const statusText = response.statusText
        const statusCode = response.status
        const errorType = json && json.errorType
        const data = json && json.data

        switch (statusCode) {
            case 401:
                throw new UnauthorizedError(statusText, errorType, data)
            case 403:
                throw new ForbiddenError(statusText, errorType, data)
            case 404:
                throw new NotFoundError(statusText, errorType, data)
            default: 
                throw new ServerError(statusText, statusCode, errorType, data)
        }
    })
}

export function headerResponse(response) {
    const contentRangeHeader = response.headers.get('Content-Range')
    const header = {}

    if (contentRangeHeader) {
        const [offset, limit, count] = contentRangeHeader.split(/[-/]/)
        header.contentRange = {
            offset: parseInt(offset),
            limit: parseInt(limit),
            count: parseInt(count)
        }
    }

    return header
}

export function jsonResponse(response) {
    return getSafeJson(response)
}

export function apiResponse(response, option) {
    return Promise.resolve(errorResponse(response, option)).then((response) => {
        return Promise.all([headerResponse(response), jsonResponse(response)])
        .then(([headers, json]) => ({response, headers, json}))
    })
}

export function only(statusCodesOrTypes, callback) {
    statusCodesOrTypes = (statusCodesOrTypes instanceof Array) && statusCodesOrTypes || [statusCodesOrTypes]

    return (error) => {
        if (statusCodesOrTypes.indexOf(error.statusCode) >= 0 || statusCodesOrTypes.indexOf(error.type) >= 0) return callback(error)
        return Promise.reject(error)
    }
}

function getSafeJson(response) {
    const contentType = response.headers.get('Content-Type')
    if (contentType && contentType.match(/application\/json/i)) {
        return response.json()
    }
    return Promise.resolve({})
}


// WEBPACK FOOTER //
// ./lib/core/fetchz.js